import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Contact } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<Contact> {

	return {
		rowName: { singular: 'Contact', plural: 'Contacts' },
		getRowKey: row => '' + row.contactId,
		stateKey: 'devo-donors-contacts-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
